module.exports = __webpack_public_path__ + "static/img/4.878050f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/temp/4.jpg
// module id = rOAw
// module chunks = 1